import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { map } from 'rxjs';

import { StateManagerProjectService } from '@state-manager/state-manager-project.service';
import { CornerstoneTool } from '@viewer/data';
import { IEditImageToolSettings } from '../edit-image-tools/data';

@Component({
  selector: 'app-tools-context-menu',
  templateUrl: 'context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
})
export class ContextMenuComponent implements OnInit {
  @Output() closeContextMenu = new EventEmitter<void>();

  public brushToolSettings!: IEditImageToolSettings;
  public eraserToolSettings!: IEditImageToolSettings;
  public lassoToolSettings!: IEditImageToolSettings;

  constructor(
    private _stateProjectManagerService: StateManagerProjectService
  ) {}

  ngOnInit(): void {
    this._initializeToolsSettings();
  }

  public onActivateTool(): void {
    this.closeContextMenu.emit();
  }

  private _initializeToolsSettings(): void {
    const baseSettings: IEditImageToolSettings = {
      actionMode: 'contextmenu',
      label: '',
      displayCorner: false,
      disableTooltip: true,
      displayIcon: false,
      displayHotKey: false,
      hideMenuBackdrop: true,
      openMenuByContext: true,
      menuClass: 'context-tool-menu',
      menuItemClass: 'context-tool-menu-item',
      menuPosition: {
        x: 'after',
        y: 'below',
      },
    };

    const currentTool = this._stateProjectManagerService.currentTool;
    const currentTool$ = this._stateProjectManagerService.currentTool$;

    this.brushToolSettings = {
      ...baseSettings,
      openMenu: this._isToolActive(currentTool, 'brush'),
      closeMenuCondition$: currentTool$.pipe(
        map((tool) => !this._isToolActive(tool, 'brush'))
      ),
      label: 'Brush',
    };

    this.eraserToolSettings = {
      ...baseSettings,
      openMenu: this._isToolActive(currentTool, 'eraser'),
      closeMenuCondition$: currentTool$.pipe(
        map((tool) => !this._isToolActive(tool, 'eraser'))
      ),
      label: 'Eraser',
    };

    this.lassoToolSettings = {
      ...baseSettings,
      openMenu: this._isToolActive(currentTool, 'lasso'),
      closeMenuCondition$: currentTool$.pipe(
        map((tool) => !this._isToolActive(tool, 'lasso'))
      ),
      label: 'Lasso',
    };
  }

  private _isToolActive(
    currentTool: CornerstoneTool | null,
    toolType: 'brush' | 'eraser' | 'lasso'
  ): boolean {
    if (!currentTool) {
      return false;
    }

    switch (toolType) {
      case 'brush':
        return [
          CornerstoneTool.CircleBrush,
          CornerstoneTool.SquareBrush,
        ].includes(currentTool);
      case 'eraser':
        return [
          CornerstoneTool.EraseCircleBrush,
          CornerstoneTool.EraseSquareBrush,
        ].includes(currentTool);
      case 'lasso':
        return [CornerstoneTool.CustomPolylineFreehand].includes(currentTool);
    }
  }
}
